import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/SuspenseFallbackComponent/SuspenseFallbackComponent.tsx");
